<template>
	<div class="flex flex-col gap-0.5 bg-white shadow sm:rounded-lg p-4 m-4">
		<div class="flex justify-between w-full gap-2 mb-4">
			<PageLabel :helpPageName="'SystemConfiguration'">Login Page</PageLabel>
			<div class="flex items-center gap-2">
				<Checkbox v-model="isDisclaimerEnabled" binary />
				<label class="text-sm font-medium cursor-pointer" @click="isDisclaimerEnabled = !isDisclaimerEnabled">Show Disclaimer</label>
			</div>
		</div>

		<div>
			<div class="flex w-full full-width">
				<div class="flex flex-column full-width lca-login-background-color">
					<div class="login full-width">
						<div class="color-picker-btn-container login-bg-picker">
							<Button
								@click="activateColorPickerForElement('login', $event)"
								size="small"
								severity="secondary"
								:class="['color-picker-btn', { active: activeColorSection === 'login' && showPicker }]"
								title="Change login background color"
							>
								<i class="pi pi-palette"></i>
							</Button>
						</div>
						<div class="login-main-content">
							<div class="sign-in">
								<div class="color-picker-btn-container">
									<Button
										@click="activateColorPickerForElement('sign-in', $event)"
										size="small"
										severity="secondary"
										:class="['color-picker-btn', { active: activeColorSection === 'sign-in' && showPicker }]"
										title="Change sign-in colors"
									>
										<i class="pi pi-palette"></i>
									</Button>
								</div>
								<div class="image-upload-container">
									<input
										type="file"
										ref="fileInput2"
										@change="handleLoginImageUpload"
										accept="image/jpeg,image/jpg,image/png,image/gif,image/bmp,image/svg+xml,image/webp,image/tiff"
										style="display: none"
									/>
									<Button @click="triggerLoginImageUpload" class="upload-btn mr-3">{{ loginImage ? "Replace" : "Upload" }} Image</Button>
									<Button @click="removeLoginImage" class="upload-btn" v-show="loginImage">Remove Image</Button>
								</div>
								<div class="logo">
									<div v-if="loginImage" v-html="loginImage"></div>
									<FontAwesomeIcon :icon="['fa', 'spinner']" class="text-blue-500 mt-3 ml-2" spin v-show="spinnerLoginImage" />
								</div>

								<div class="login-button-container">
									<button type="button" id="btnLogin" class="btn loginButton">Login</button>
									<div class="color-picker-btn-container">
										<Button
											@click="activateColorPickerForElement('loginButton', $event)"
											size="small"
											severity="secondary"
											:class="['color-picker-btn', { active: activeColorSection === 'loginButton' && showPicker }]"
											title="Change login button color"
										>
											<i class="pi pi-palette"></i>
										</Button>
									</div>
								</div>

								<div>Version !!!</div>

								<div>
									<div id="branchInfo">Branch:</div>
									<div id="commitInfo">Commit: 6600941</div>
									<!-- <div v-if="environmentSettings.environmentName == 'Development'" id="lastDescription">Description:</div> -->
									<div id="commitDate">2025-05-19 17:50:33 -0400</div>
								</div>
							</div>

							<div class="graphic">
								<div class="image-upload-container">
									<input
										type="file"
										ref="fileInput"
										@change="handleImageUpload"
										accept="image/jpeg,image/jpg,image/png,image/gif,image/bmp,image/svg+xml,image/webp,image/tiff"
										style="display: none"
									/>
									<Button @click="triggerImageUpload" class="upload-btn mr-3">{{ logoImage ? "Replace" : "Upload" }} Image</Button>
									<Button @click="removeImage" class="upload-btn" v-show="logoImage">Remove Image</Button>
								</div>
								<!-- <div 
									v-html="logoImage" 
									class="logo-container clickable-logo" 
									@click="handleSvgClick"
									:class="{ 'color-edit-mode': logoImage }"
								></div> -->
								<div class="logo">
									<div v-if="logoImage" v-html="logoImage"></div>
									<FontAwesomeIcon :icon="['fa', 'spinner']" class="text-blue-500 mt-3 ml-2" spin v-show="spinnerLogoImage" />
								</div>
							</div>
						</div>

						<div v-if="isDisclaimerEnabled" class="sign-in1">
							<div class="disclaimer-header">
								<button @click="toggleEditMode" class="edit-disclaimer-btn" title="Edit disclaimer text">
									<i class="pi pi-pencil"></i>
								</button>
							</div>

							<div v-if="!isEditingDisclaimer">
								<!-- <span class="disclaimer-title" style="font-size: 20px; font-weight: bold">{{ disclaimerTitle }}</span>
								<span class="disclaimer-text">{{ disclaimerText }}</span> -->
								<span v-html="disclaimerContent"></span>
							</div>

							<div v-else class="disclaimer-edit-form">
								<Editor v-model="disclaimerContent" editorStyle="height: 320px" />
								<Button @click="saveDisclaimer">Save</Button>
								<!-- <div class="edit-field">
									<label>Title:</label>
									<InputText v-model="editDisclaimerTitle" class="disclaimer-input" />
								</div>
								<div class="edit-field">
									<label>Text:</label>
									<Textarea v-model="editDisclaimerText" class="disclaimer-textarea" rows="4" />
								</div>
								<div class="edit-controls">
									<Button @click="saveDisclaimer" size="small" class="save-btn editingDisclaimer"> <i class="pi pi-check"></i> Save </Button>
									<Button @click="cancelEdit" size="small" severity="secondary" class="cancel-btn editingDisclaimer">
										<i class="pi pi-times"></i> Cancel
									</Button>
								</div> -->
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- Logo Color Picker Panel -->
		<div
			v-if="logoColorPicker"
			:style="{
				position: 'fixed',
				top: clickPosition.y + 'px',
				left: clickPosition.x + 'px',
				zIndex: 1000,
			}"
			class="logo-color-picker-panel"
		>
			<div class="color-picker-header">
				<span class="color-picker-title">Edit Color</span>
				<button @click="closeLogoColorPicker" class="color-picker-close">×</button>
			</div>

			<div v-if="!isTransparent" class="color-picker-content">
				<ColorPicker
					ref="logoColorPickerRef"
					v-model="selectedColor"
					inline
					class="logo-color-picker"
					@input="onColorPickerInput"
					@change="onLogoColorPickerChange"
				/>

				<div class="hex-input-container">
					<label for="hexInput" class="hex-input-label">Hex:</label>
					<InputText
						id="hexInput"
						v-model="hexInputValue"
						@input="onHexInputChange"
						@blur="validateAndApplyHex"
						class="hex-input"
						placeholder="#ffffff"
						maxlength="7"
					/>
					<Button @click="sendColorToParent" size="small" class="send-color-btn" title="Use it to generate color scheme">
						<i class="pi pi-arrow-up"></i>
					</Button>
				</div>
			</div>

			<div v-else class="transparency-message">
				<i class="pi pi-eye-slash"></i>
				<span>Transparent</span>
			</div>

			<div class="color-picker-controls">
				<div class="color-debug-info">
					<small>Current: {{ selectedColor }}</small>
					<div class="color-preview" :style="{ backgroundColor: selectedColor }"></div>
				</div>

				<label class="transparency-control">
					<input type="checkbox" v-model="isTransparent" @change="handleTransparencyToggle" />
					<span>Make Transparent</span>
				</label>
			</div>
		</div>

		<!-- Color Picker Panel - using same structure as Components file -->
		<div v-if="showPicker" :style="{ position: 'fixed', top: pickerY + 'px', left: pickerX + 'px', zIndex: 9999 }" class="color-picker-panel">
			<div class="color-picker-header">
				<span class="color-picker-title">Edit Color</span>
				<button @click="closePicker" class="color-picker-close">×</button>
			</div>

			<!-- Mode switching tabs -->
			<div class="mode-tabs">
				<Button @click="switchColorMode('background', $event)" :class="['mode-tab', { active: colorMode === 'background' }]" size="small">
					Background
				</Button>
				<Button @click="switchColorMode('text', $event)" :class="['mode-tab', { active: colorMode === 'text' }]" size="small">
					<i class="pi pi-font"></i> Text
				</Button>
			</div>

			<!-- Auto Contrast Checkbox -->
			<div v-if="colorMode === 'background'" class="auto-contrast-section">
				<div class="flex items-center gap-2 p-2 border-t border-gray-200">
					<Checkbox v-model="autoContrast" inputId="autoContrast" binary />
					<label for="autoContrast" class="text-sm text-gray-700 cursor-pointer"> Auto contrast </label>
					<i
						class="pi pi-question-circle text-gray-400 cursor-help"
						title="Automatically adjusts text color (black/white) based on background brightness"
					></i>
				</div>
			</div>

			<div class="color-picker-content">
				<ColorPicker
					v-if="colorMode === 'background'"
					v-model="selectedColor"
					@update:modelValue="onColorPickerChange"
					inline
					ref="colorPickerRef"
					class="color-picker"
				/>
				<ColorPicker v-else v-model="selectedTextColor" @update:modelValue="onColorPickerChange" inline ref="colorPickerRef" class="color-picker" />
				<div class="color-palette-miniatures" v-if="paletteColors">
					<div class="palette-grid">
						<!-- Primary, Secondary, Accent with border -->
						<div class="primary-colors-box">
							<div class="palette-row primary-row">
								<div
									v-for="(color, index) in getPrimaryColors()"
									:key="index"
									class="palette-swatch primary-swatch"
									:style="{ backgroundColor: color.value }"
									@click="selectPaletteColor(color.value)"
									:title="color.name"
								></div>
							</div>
						</div>
						<!-- Other colors -->
						<div class="palette-row">
							<div
								v-for="(color, index) in getOtherColors().slice(0, 3)"
								:key="index"
								class="palette-swatch"
								:style="{ backgroundColor: color.value }"
								@click="selectPaletteColor(color.value)"
							></div>
						</div>
						<div class="palette-row">
							<div
								v-for="(color, index) in getOtherColors().slice(3, 6)"
								:key="index"
								class="palette-swatch"
								:style="{ backgroundColor: color.value }"
								@click="selectPaletteColor(color.value)"
							></div>
						</div>
						<div class="palette-row">
							<div
								v-for="(color, index) in getOtherColors().slice(6, 9)"
								:key="index"
								class="palette-swatch"
								:style="{ backgroundColor: color.value }"
								@click="selectPaletteColor(color.value)"
							></div>
						</div>
					</div>
				</div>
			</div>
			<div class="hex-input-container">
				<label for="hexInput" class="hex-input-label">Hex:</label>
				<InputText
					id="hexInput"
					v-model="hexInputValue"
					@input="onHexInputChange"
					@blur="validateAndApplyHex"
					class="hex-input"
					placeholder="#ffffff"
					maxlength="7"
				/>
				<Button @click="sendColorToParent" size="small" class="send-color-btn" title="Use it to generate color scheme">
					<i class="pi pi-arrow-up"></i>
				</Button>
			</div>
		</div>
	</div>
</template>
<script setup lang="ts">
import { ref, onMounted, nextTick, watch } from "vue"
import { ThemeState, ThemeTemplate, ThemeMgmClient, TemplateUI } from "../../../entities/NSwagGenerated"
import ColorPicker from "primevue/colorpicker"
import InputText from "primevue/inputtext"
import Textarea from "primevue/textarea"
import Button from "primevue/button"
import Checkbox from "primevue/checkbox"
import PVCheckbox from "primevue/checkbox"
import Editor from "primevue/editor"
import PageLabel from "../pageLabel.vue"
import { library } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { faTriangleExclamation, faSpinner, faBan } from "@fortawesome/free-solid-svg-icons"
library.add(faTriangleExclamation, faSpinner, faBan)
const props = defineProps<{
	selectedTemplate?: ThemeState
	selectedColor?: string
	paletteColors?: Record<string, string>
}>()
const emit = defineEmits<{
	(e: "updateTheme", themeData: ThemeState): void
	(e: "colorSelected", color: string): void
	(e: "disablePasteColor"): void
	(e: "saveToUndo"): void
}>()

// Functions for palette colors
const getPrimaryColors = () => {
	if (!props.paletteColors) return []
	return [
		{ name: "Primary", value: props.paletteColors["0"] },
		{ name: "Secondary", value: props.paletteColors["1"] },
		{ name: "Accent", value: props.paletteColors["2"] },
	]
}

const getOtherColors = () => {
	if (!props.paletteColors) return []
	const colors = []
	for (let i = 3; i < 12; i++) {
		if (props.paletteColors[i.toString()]) {
			colors.push({ name: "", value: props.paletteColors[i.toString()] })
		}
	}
	return colors
}

const selectPaletteColor = (color: string) => {
	// Set the appropriate color based on current mode
	if (colorMode.value === "text") {
		selectedTextColor.value = color
	} else {
		selectedColor.value = color
	}

	// Update the hex input
	hexInputValue.value = color.toUpperCase()

	// Apply the color change
	onColorPickerChange(color)
}

// Function to save pending image uploads
const savePendingImages = async (): Promise<void> => {
	const promises: Promise<void>[] = []

	// Check if theme ID is available
	if (!localThemeState.value.id) {
		throw new Error("Theme not found. Cannot save images without a theme selected.")
	}

	// Upload SVG image if pending
	if (pendingUploads.value.svgImageFile) {
		promises.push(
			uploadBinaryImage(pendingUploads.value.svgImageFile, "logo", localThemeState.value.id).then(() => {
				pendingUploads.value.svgImageFile = null
			})
		)
	}

	// Upload login image if pending
	if (pendingUploads.value.loginImageFile) {
		promises.push(
			uploadBinaryImage(pendingUploads.value.loginImageFile, "login", localThemeState.value.id).then(() => {
				pendingUploads.value.loginImageFile = null
			})
		)
	}

	// Wait for all uploads to complete
	if (promises.length > 0) {
		await Promise.all(promises)
	}
}

// Expose the function to parent component
defineExpose({
	savePendingImages,
})
const localThemeSettings = ref<ThemeTemplate>(new ThemeTemplate())
const localThemeState = ref<ThemeState>(new ThemeState())
// Ensure templateUI is always initialized
if (!localThemeState.value.templateUI) {
	localThemeState.value.templateUI = new TemplateUI()
}
const showPicker = ref<boolean>(false)
const activeColorSection = ref<string | null>(null)
const spinnerLoginImage = ref<boolean>(false)
const spinnerLogoImage = ref<boolean>(false)
const selectedColor = ref<string>("")
const selectedTextColor = ref<string>("")
const pickerX = ref<number>(0)
const pickerY = ref<number>(0)
const colorMode = ref<"background" | "text">("background")
const fileInput = ref<HTMLInputElement | null>(null)
const fileInput2 = ref<HTMLInputElement | null>(null)
const logoImage = ref<string | null>(null)
const loginImage = ref<string | null>(null)
let clickedElement: HTMLElement | null = null

// State for pending image uploads
const pendingUploads = ref<{
	svgImageFile: File | null
	loginImageFile: File | null
}>({
	svgImageFile: null,
	loginImageFile: null,
})
const themeMgmClient = new ThemeMgmClient(import.meta.env.VITE_API_URL?.toString())

// Function to upload binary image
const uploadBinaryImage = async (file: File, imageType: "logo" | "login", themeId: string): Promise<any> => {
	const formData = new FormData()
	formData.append("file", file)
	formData.append("imageType", imageType)
	formData.append("themeId", themeId)

	try {
		const response = await fetch(`${import.meta.env.VITE_API_URL}/api/themeMgm/uploadImage`, {
			method: "POST",
			headers: {
				Authorization: `Bearer ${localStorage.getItem("token")}`,
			},
			body: formData,
		})

		if (!response.ok) {
			throw new Error(`Failed to upload image: ${response.statusText}`)
		}

		return await response.json()
	} catch (error) {
		console.error("Error uploading binary image:", error)
		throw error
	}
}

onMounted(async () => {
	// Load default theme if no theme is selected
	if (!props.selectedTemplate || !props.selectedTemplate.id) {
		try {
			const defaultTheme = await themeMgmClient.getDefaultTheme()
			if (defaultTheme) {
				// Ensure templateUI is initialized
				if (!defaultTheme.templateUI) {
					defaultTheme.templateUI = new TemplateUI()
				}
				localThemeState.value = defaultTheme
			}
		} catch (error) {
			console.error("Error loading default theme:", error)
		}
	}
})

let styleVars: { [key: string]: string } = {}

// Function to create image HTML from binary data
const createImageFromBinary = (binaryData: string, contentType: string): string => {
	if (!binaryData) return ""

	// Check if binaryData is already a data URL
	if (binaryData.startsWith("data:")) {
		return `<img src="${binaryData}" alt="Image" style="max-width: 100%; max-height: 600px; height: auto; object-fit: contain; background: transparent;" class="transparent-image" />`
	}

	// Handle SVG files specially
	if (contentType === "image/svg+xml" || contentType.includes("svg")) {
		// For SVG, try to decode as text first
		try {
			const svgContent = atob(binaryData)
			// If it's valid SVG content, return it with size constraints
			if (svgContent.includes("<svg")) {
				// Add viewBox and size constraints to SVG
				const modifiedSvg = svgContent.replace(
					/<svg([^>]*)>/,
					'<svg$1 style="max-width: 100%; max-height: 600px; height: auto; width: auto; object-fit: contain;">'
				)
				return modifiedSvg
			}
		} catch (error) {
			// If decoding fails, fall back to data URL
			console.log("SVG decode failed, using data URL:", error)
		}
	}

	// Check if binaryData is already base64 encoded
	let base64Data = binaryData
	if (!binaryData.startsWith("/9j") && !binaryData.startsWith("iVBOR") && !binaryData.startsWith("R0lGOD") && !binaryData.startsWith("PHN2Zw")) {
		// If not base64, assume it's already binary and convert to base64
		try {
			base64Data = btoa(binaryData)
		} catch (error) {
			console.error("Error encoding binary data to base64:", error)
			return ""
		}
	}

	const dataUrl = `data:${contentType};base64,${base64Data}`
	return `<img src="${dataUrl}" alt="Image" style="max-width: 100%; max-height: 600px; height: auto; object-fit: contain; background: transparent;" class="transparent-image" />`
}

const applyTemplate = async (selectedTemplate: ThemeState) => {
	localThemeSettings.value = selectedTemplate.selectedTheme!

	// Ensure templateUI is initialized
	if (!selectedTemplate.templateUI) {
		selectedTemplate.templateUI = new TemplateUI()
	}
	localThemeState.value = selectedTemplate

	// Handle logo image binary data
	if (selectedTemplate.templateUI?.logoImageBinary) {
		const logoContentType = selectedTemplate.templateUI.logoImageContentType || "image/png"
		logoImage.value = createImageFromBinary(selectedTemplate.templateUI.logoImageBinary, logoContentType)
	} else {
		logoImage.value = null
	}

	// Handle login image binary data
	if (selectedTemplate.templateUI?.loginImageBinary) {
		const loginContentType = selectedTemplate.templateUI.loginImageContentType || "image/png"

		loginImage.value = createImageFromBinary(selectedTemplate.templateUI.loginImageBinary, loginContentType)
	} else {
		loginImage.value = null
	}

	// Handle disclaimer data
	if (selectedTemplate.templateUI) {
		isDisclaimerEnabled.value = selectedTemplate.templateUI.isDiscaimerVisible ?? true
		if (selectedTemplate.templateUI.disclaimerContent) {
			disclaimerContent.value = selectedTemplate.templateUI.disclaimerContent
		}
	}

	// Ensure transparency is preserved for existing images
	if (logoImage.value && logoImage.value.includes("<img")) {
		logoImage.value = logoImage.value.replace(
			/<img([^>]*?)style="([^"]*?)"([^>]*?)>/g,
			'<img$1style="$2; background: transparent !important;" class="transparent-image"$3>'
		)
		// Add class if not present
		if (!logoImage.value.includes('class="transparent-image"')) {
			logoImage.value = logoImage.value.replace(/<img([^>]*?)>/g, '<img$1 class="transparent-image">')
		}
	}
	if (loginImage.value && loginImage.value.includes("<img")) {
		loginImage.value = loginImage.value.replace(
			/<img([^>]*?)style="([^"]*?)"([^>]*?)>/g,
			'<img$1style="$2; background: transparent !important;" class="transparent-image"$3>'
		)
		// Add class if not present
		if (!loginImage.value.includes('class="transparent-image"')) {
			loginImage.value = loginImage.value.replace(/<img([^>]*?)>/g, '<img$1 class="transparent-image">')
		}
	}

	// Force transparency handling after DOM update
	nextTick(() => {
		const images = document.querySelectorAll(".logo img, .graphic img")
		images.forEach((img) => {
			const htmlImg = img as HTMLImageElement
			htmlImg.style.background = "transparent"
			htmlImg.style.backgroundColor = "transparent"
			// Ensure container transparency
			if (htmlImg.parentElement) {
				htmlImg.parentElement.style.background = "transparent"
				htmlImg.parentElement.style.backgroundColor = "transparent"
			}
		})
	})
	nextTick(() => {
		// Reset all inline styles applied by the color picker
		const elementsWithInlineStyles = document.querySelectorAll('[style*="background-color"]')
		elementsWithInlineStyles.forEach((element) => {
			const htmlElement = element as HTMLElement
			htmlElement.style.removeProperty("background-color")
		})

		styleVars = {
			"--lca-login-background-color": localThemeSettings.value.semantic?.loginScreen?.loginBackground?.color!,
			"--lca-login-button-color": localThemeSettings.value.semantic?.loginScreen?.loginButton?.backgroundColor!,
			"--lca-login-button-hovercolor": localThemeSettings.value.semantic?.loginScreen?.loginButton?.backgroundColorHover!,
			"--lca-login-text-color": localThemeSettings.value.semantic?.loginScreen?.loginButton?.textColor!,
			"--lca-login-signin-color": localThemeSettings.value.semantic?.loginScreen?.loginSignin?.color!,
		}
		Object.entries(styleVars).forEach(([key, value]) => {
			document.documentElement.style.setProperty(key, value || "#ffffff")
		})
	})
}

// Direct logo color editing
const activeLogoElement = ref<SVGPathElement | null>(null)
const logoColorPicker = ref(false)
const clickPosition = ref({ x: 0, y: 0 })
const pickerOpenTime = ref(0)
const isTransparent = ref(false)
const logoColorPickerRef = ref<InstanceType<typeof ColorPicker> | null>(null)
const colorPickerRef = ref<InstanceType<typeof ColorPicker> | null>(null)
const standardHexInputValue = ref<string>("")
const textHexInputValue = ref<string>("")
const hexInputValue = ref<string>("")
const autoContrast = ref<boolean>(true) // Auto-contrast enabled by default

// Color monitoring variables
let colorMonitoringInterval: number | null = null
let colorMutationObserver: MutationObserver | null = null

// Disclaimer editing variables
const isDisclaimerEnabled = ref<boolean>(true)
const isEditingDisclaimer = ref<boolean>(false)
// const disclaimerTitle = ref<string>("Notice: You are accessing a third-party system.")
// const disclaimerText = ref<string>(
// 	"Please ensure that you comply with all applicable policies and procedures relating to the access and use of third-party systems, including policies relating to confidentiality and the protection of personal data."
// )
const disclaimerContent = ref<string>(
	`<h2 class="ql-align-center"><span style="color: rgb(0, 138, 0);">Notice:&nbsp;You&nbsp;are&nbsp;accessing&nbsp;a&nbsp;third-party&nbsp;system.</span></h2><p class="ql-align-center"></p><p class="ql-align-center"></p><p><span style="color: rgb(68, 68, 68);">Please&nbsp;ensure&nbsp;that&nbsp;you&nbsp;comply&nbsp;with&nbsp;all&nbsp;applicable&nbsp;policies&nbsp;and&nbsp;procedures&nbsp;relating&nbsp;to&nbsp;the&nbsp;access&nbsp;and&nbsp;use&nbsp;of&nbsp;third-party&nbsp;systems,&nbsp;including&nbsp;policies&nbsp;relating&nbsp;to&nbsp;confidentiality&nbsp;and&nbsp;the&nbsp;protection&nbsp;of&nbsp;personal&nbsp;data.</span></p>`
)
const editDisclaimerTitle = ref<string>("")
const editDisclaimerText = ref<string>("")

// Handle logo click for direct color editing
const handleLogoClick = (event: MouseEvent) => {
	if (!logoImage.value) return

	event.preventDefault()
	event.stopPropagation()

	const target = event.target as Element

	// Check if clicked element is a path (logo shape)
	if (target.tagName === "path") {
		const logoPath = target as SVGPathElement
		activeLogoElement.value = logoPath

		// Get click position relative to viewport and adjust to keep panel on screen
		const panelWidth = 280
		const panelHeight = 400
		const viewportWidth = window.innerWidth
		const viewportHeight = window.innerHeight

		let x = event.clientX
		let y = event.clientY

		// Adjust X position if panel would go off-screen
		if (x + panelWidth > viewportWidth) {
			x = viewportWidth - panelWidth - 20
		}

		// Adjust Y position if panel would go off-screen
		if (y + panelHeight > viewportHeight) {
			y = y - panelHeight - 20
		}

		// Ensure minimum margins
		x = Math.max(20, x)
		y = Math.max(20, y)

		clickPosition.value = { x, y }

		// Show the logo color picker
		logoColorPicker.value = true
		pickerOpenTime.value = Date.now()

		// Start monitoring color changes
		startColorMonitoring()

		// Get current color of the path and convert to hex format
		const currentFill = logoPath.getAttribute("fill") || "#000000"
		let hexColor = currentFill

		// Convert rgb() format to hex if needed
		if (currentFill.startsWith("rgb(")) {
			const rgbMatch = currentFill.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/)
			if (rgbMatch) {
				const r = parseInt(rgbMatch[1]).toString(16).padStart(2, "0")
				const g = parseInt(rgbMatch[2]).toString(16).padStart(2, "0")
				const b = parseInt(rgbMatch[3]).toString(16).padStart(2, "0")
				hexColor = `#${r}${g}${b}`
			}
		}

		// Ensure hex format and set selected color
		if (!hexColor.startsWith("#")) hexColor = "#" + hexColor
		selectedColor.value = hexColor
		hexInputValue.value = hexColor

		// Check if the element is transparent (has fill-opacity="0" or fill="transparent" or fill="none")
		const opacity = logoPath.getAttribute("fill-opacity")
		const fill = logoPath.getAttribute("fill")
		isTransparent.value = opacity === "0" || fill === "transparent" || fill === "none"

		nextTick(() => {
			// Add listeners with a small delay to prevent immediate closure
			setTimeout(() => {
				document.addEventListener("click", handleClickOutsideLogoPicker)
				document.addEventListener("keydown", handleEscKey)
			}, 100)
		})
	}
}

// Handle clicks outside the logo color picker
const handleClickOutsideLogoPicker = (event: MouseEvent) => {
	// Prevent immediate closure after opening
	if (Date.now() - pickerOpenTime.value < 200) {
		return
	}

	const target = event.target as HTMLElement

	// Check if click is on color picker elements or logo paths
	const tagName = target.tagName.toLowerCase()
	const className = target.className || ""

	if (
		target.closest(".logo-color-picker, .p-colorpicker, [class*='p-colorpicker'], [class*='color']") ||
		tagName === "path" ||
		tagName === "canvas" ||
		className.includes("colorpicker") ||
		className.includes("color")
	) {
		return
	}

	// Close the picker
	closeLogoColorPicker()
}

// Handle ESC key to close color picker
const handleEscKey = (event: KeyboardEvent) => {
	if (event.key === "Escape" && logoColorPicker.value) {
		closeLogoColorPicker()
	}
}

// Close logo color picker
const closeLogoColorPicker = () => {
	stopColorMonitoring()
	logoColorPicker.value = false
	activeLogoElement.value = null
	isTransparent.value = false
	document.removeEventListener("click", handleClickOutsideLogoPicker)
	document.removeEventListener("keydown", handleEscKey)
}

// Handle transparency toggle
const handleTransparencyToggle = () => {
	if (!activeLogoElement.value) return

	if (isTransparent.value) {
		// Make transparent
		activeLogoElement.value.setAttribute("fill-opacity", "0")
		activeLogoElement.value.setAttribute("fill", "transparent")
	} else {
		// Make opaque with selected color
		activeLogoElement.value.removeAttribute("fill-opacity")
		activeLogoElement.value.setAttribute("fill", selectedColor.value)
	}

	// Update stored logo content
	const logoContainer = document.querySelector(".logo-container")
	if (logoContainer) {
		logoImage.value = logoContainer.innerHTML
		// Store the updated image data in binary fields instead of svgImage
		emit("updateTheme", localThemeState.value)
	}
}

// Apply color to selected logo element in real time (without closing picker)
const applyLogoColorRealtime = (newColorValue: string) => {
	if (!activeLogoElement.value || isTransparent.value) return

	// Handle different color formats
	let finalColor = newColorValue
	if (typeof newColorValue === "string") {
		// Ensure hex format
		if (!newColorValue.startsWith("#")) {
			finalColor = "#" + newColorValue
		}
	}

	// Update the logo element's fill color (only if not transparent)
	activeLogoElement.value.setAttribute("fill", finalColor)
	activeLogoElement.value.removeAttribute("fill-opacity") // Ensure it's opaque

	// Update the stored logo content
	const logoContainer = document.querySelector(".logo-container")
	if (logoContainer) {
		logoImage.value = logoContainer.innerHTML
		// Store the updated image data in binary fields instead of svgImage
		emit("updateTheme", localThemeState.value)
	}
}

// Helper function to extract dominant colors
const extractDominantColors = (imageData: ImageData, numColors: number) => {
	const pixels: number[][] = []
	const data = imageData.data

	// Sample pixels (every 10th pixel to improve performance)
	for (let i = 0; i < data.length; i += 40) {
		// 40 = 4 * 10 (RGBA * skip)
		if (data[i + 3] > 128) {
			// Only non-transparent pixels
			pixels.push([data[i], data[i + 1], data[i + 2]])
		}
	}

	// Simple color quantization - group similar colors
	const colors: number[][] = []
	const tolerance = 30

	pixels.forEach((pixel) => {
		let found = false
		for (const existingColor of colors) {
			if (colorDistance(pixel, existingColor) < tolerance) {
				found = true
				break
			}
		}
		if (!found && colors.length < numColors) {
			colors.push(pixel)
		}
	})

	return colors
}

// Helper function to calculate color distance
const colorDistance = (color1: number[], color2: number[]): number => {
	return Math.sqrt(Math.pow(color1[0] - color2[0], 2) + Math.pow(color1[1] - color2[1], 2) + Math.pow(color1[2] - color2[2], 2))
}

// Handle ColorPicker input events (during dragging)
const onColorPickerInput = (value: any) => {
	if (logoColorPicker.value && activeLogoElement.value && !isTransparent.value) {
		applyLogoColorRealtime(value)
	}
}

// Handle ColorPicker change events (on click/final selection) for logo
const onLogoColorPickerChange = (value: any) => {
	if (logoColorPicker.value && activeLogoElement.value && !isTransparent.value) {
		applyLogoColorRealtime(value)
	}
}

// Enhanced color monitoring system
let lastDetectedColor = ""
let colorElements: HTMLElement[] = []

const startColorMonitoring = () => {
	lastDetectedColor = selectedColor.value
	stopColorMonitoring() // Clean up any existing monitoring

	// Wait for ColorPicker to be rendered
	nextTick(() => {
		setTimeout(() => {
			setupAdvancedColorMonitoring()
		}, 100)
	})
}

const setupAdvancedColorMonitoring = () => {
	if (!logoColorPickerRef.value) return

	try {
		// Try to access the ColorPicker DOM element
		const pickerElement = (logoColorPickerRef.value as any).$el || logoColorPickerRef.value

		if (pickerElement) {
			// Method 1: MutationObserver for DOM changes
			colorMutationObserver = new MutationObserver((mutations) => {
				mutations.forEach((mutation) => {
					if (mutation.type === "attributes" || mutation.type === "childList") {
						detectColorChanges()
					}
				})
			})

			colorMutationObserver.observe(pickerElement, {
				attributes: true,
				childList: true,
				subtree: true,
				attributeOldValue: true,
			})

			// Method 2: Direct event listeners on all interactive elements
			const interactiveElements = pickerElement.querySelectorAll("*")
			interactiveElements.forEach((element: HTMLElement) => {
				// Add multiple event types to catch all interactions
				const events = ["click", "mousedown", "mouseup", "mousemove", "input", "change"]
				events.forEach((eventType) => {
					element.addEventListener(eventType, detectColorChanges, { passive: true })
				})
			})

			// Store elements for cleanup
			colorElements = Array.from(interactiveElements) as HTMLElement[]
		}
	} catch (error) {
		console.log("Error setting up color monitoring:", error)
	}

	// Method 3: Aggressive polling as fallback
	if (colorMonitoringInterval) {
		clearInterval(colorMonitoringInterval)
	}

	colorMonitoringInterval = window.setInterval(() => {
		detectColorChanges()
	}, 25) // Very fast polling at 25ms
}

const detectColorChanges = () => {
	if (!logoColorPicker.value || !activeLogoElement.value) return

	// Check v-model value
	if (selectedColor.value !== lastDetectedColor) {
		updateLogoColor(selectedColor.value)
		return
	}

	// Check DOM elements for color information
	if (logoColorPickerRef.value) {
		try {
			const pickerElement = (logoColorPickerRef.value as any).$el || logoColorPickerRef.value

			// Check all possible color-containing elements
			const colorSelectors = [
				'input[type="text"]',
				'[style*="background-color"]',
				'[style*="background"]',
				".p-colorpicker-color-handle",
				".p-colorpicker-color",
				'[data-pc-section="color"]',
			]

			for (const selector of colorSelectors) {
				const elements = pickerElement.querySelectorAll(selector)
				elements.forEach((element: HTMLElement) => {
					// Check input values
					if (element instanceof HTMLInputElement && element.value) {
						const value = element.value
						if (value.startsWith("#") && value.length >= 7 && value !== lastDetectedColor) {
							updateLogoColor(value)
							return
						}
					}

					// Check computed styles
					const computedStyle = getComputedStyle(element)
					const bgColor = computedStyle.backgroundColor
					if (bgColor && bgColor !== "rgba(0, 0, 0, 0)" && bgColor !== "transparent") {
						const hexColor = rgbToHex(bgColor)
						if (hexColor !== lastDetectedColor && hexColor !== "#000000") {
							updateLogoColor(hexColor)
							return
						}
					}
				})
			}
		} catch (error) {
			// Silently handle errors
		}
	}
}

const updateLogoColor = (newColor: string) => {
	lastDetectedColor = newColor
	selectedColor.value = newColor
	hexInputValue.value = newColor
	if (!isTransparent.value) {
		applyLogoColorRealtime(newColor)
	}
}

// Stop color monitoring
const stopColorMonitoring = () => {
	// Clear interval
	if (colorMonitoringInterval) {
		clearInterval(colorMonitoringInterval)
		colorMonitoringInterval = null
	}

	// Disconnect MutationObserver
	if (colorMutationObserver) {
		colorMutationObserver.disconnect()
		colorMutationObserver = null
	}

	// Remove event listeners
	if (colorElements.length > 0) {
		const events = ["click", "mousedown", "mouseup", "mousemove", "input", "change"]
		colorElements.forEach((element) => {
			events.forEach((eventType) => {
				element.removeEventListener(eventType, detectColorChanges)
			})
		})
		colorElements = []
	}
}
const removeImage = () => {
	logoImage.value = null
	localThemeState.value.templateUI!.logoImageBinary = undefined
	localThemeState.value.templateUI!.logoImageContentType = undefined
	localThemeState.value.templateUI!.logoImageFileName = undefined
	localThemeState.value.templateUI!.logoImageSize = undefined
	emit("updateTheme", localThemeState.value)
}
const removeLoginImage = () => {
	loginImage.value = null
	localThemeState.value.templateUI!.loginImageBinary = undefined
	localThemeState.value.templateUI!.loginImageContentType = undefined
	localThemeState.value.templateUI!.loginImageFileName = undefined
	localThemeState.value.templateUI!.loginImageSize = undefined
	emit("updateTheme", localThemeState.value)
}
const triggerImageUpload = () => {
	fileInput.value?.click()
}
const triggerLoginImageUpload = () => {
	fileInput2.value?.click()
}

const handleImageUpload = async (event: Event) => {
	const target = event.target as HTMLInputElement
	const file = target.files?.[0]

	if (!file) return

	if (!file.type.startsWith("image/")) {
		console.error("Invalid file type. Please select an image file.")
		return
	}

	// Clear previous content immediately
	logoImage.value = null
	spinnerLogoImage.value = true

	try {
		// Handle SVG files as text, others as binary
		const reader = new FileReader()
		reader.onload = (e) => {
			let base64String = ""

			if (file.type === "image/svg+xml" || file.type.includes("svg")) {
				// For SVG, read as text and encode to base64
				const svgContent = e.target?.result as string
				base64String = btoa(svgContent)
			} else {
				// For other images, read as ArrayBuffer
				const arrayBuffer = e.target?.result as ArrayBuffer
				const uint8Array = new Uint8Array(arrayBuffer)
				let binaryString = ""
				for (let i = 0; i < uint8Array.length; i++) {
					binaryString += String.fromCharCode(uint8Array[i])
				}
				base64String = btoa(binaryString)
			}

			// Clear previous image data first
			localThemeState.value.templateUI!.logoImageBinary = undefined
			localThemeState.value.templateUI!.logoImageContentType = undefined
			localThemeState.value.templateUI!.logoImageFileName = undefined
			localThemeState.value.templateUI!.logoImageSize = undefined

			// Store binary data and content type
			localThemeState.value.templateUI!.logoImageBinary = base64String
			localThemeState.value.templateUI!.logoImageContentType = file.type
			localThemeState.value.templateUI!.logoImageFileName = file.name
			localThemeState.value.templateUI!.logoImageSize = file.size

			// Create display image
			logoImage.value = createImageFromBinary(base64String, file.type)

			emit("updateTheme", localThemeState.value)
			spinnerLogoImage.value = false
		}
		reader.onerror = () => {
			console.error("Error reading file")
			alert("Failed to load image. Please try again.")
			logoImage.value = null
			spinnerLogoImage.value = false
		}

		// Read file appropriately based on type
		if (file.type === "image/svg+xml" || file.type.includes("svg")) {
			reader.readAsText(file)
		} else {
			reader.readAsArrayBuffer(file)
		}
	} catch (error: any) {
		console.error("Error loading image:", error)
		alert(error.message || "Failed to load image. Please try again.")
		logoImage.value = null
		spinnerLogoImage.value = false
	} finally {
		// Clear the input to allow re-uploading the same file
		target.value = ""
	}
}
const handleLoginImageUpload = async (event: Event) => {
	const target = event.target as HTMLInputElement
	const file = target.files?.[0]

	if (!file) return

	if (!file.type.startsWith("image/")) {
		console.error("Invalid file type. Please select an image file.")
		return
	}

	// Clear previous content immediately
	loginImage.value = null
	spinnerLoginImage.value = true

	try {
		// Handle SVG files as text, others as binary
		const reader = new FileReader()
		reader.onload = (e) => {
			let base64String = ""

			if (file.type === "image/svg+xml" || file.type.includes("svg")) {
				// For SVG, read as text and encode to base64
				const svgContent = e.target?.result as string
				base64String = btoa(svgContent)
			} else {
				// For other images, read as ArrayBuffer
				const arrayBuffer = e.target?.result as ArrayBuffer
				const uint8Array = new Uint8Array(arrayBuffer)
				let binaryString = ""
				for (let i = 0; i < uint8Array.length; i++) {
					binaryString += String.fromCharCode(uint8Array[i])
				}
				base64String = btoa(binaryString)
			}

			// Clear previous image data first
			localThemeState.value.templateUI!.loginImageBinary = undefined
			localThemeState.value.templateUI!.loginImageContentType = undefined
			localThemeState.value.templateUI!.loginImageFileName = undefined
			localThemeState.value.templateUI!.loginImageSize = undefined

			// Store binary data and content type
			localThemeState.value.templateUI!.loginImageBinary = base64String
			localThemeState.value.templateUI!.loginImageContentType = file.type
			localThemeState.value.templateUI!.loginImageFileName = file.name
			localThemeState.value.templateUI!.loginImageSize = file.size

			// Create display image
			loginImage.value = createImageFromBinary(base64String, file.type)
			// Store in loginImageBinary instead of loginImage since loginImage doesn't exist on the type

			emit("updateTheme", localThemeState.value)
			spinnerLoginImage.value = false
		}
		reader.onerror = () => {
			console.error("Error reading login image file")
			alert("Failed to load login image. Please try again.")
			loginImage.value = null
			spinnerLoginImage.value = false
		}

		// Read file appropriately based on type
		if (file.type === "image/svg+xml" || file.type.includes("svg")) {
			reader.readAsText(file)
		} else {
			reader.readAsArrayBuffer(file)
		}
	} catch (error: any) {
		console.error("Error loading login image:", error)
		alert(error.message || "Failed to load login image. Please try again.")
		loginImage.value = null
		spinnerLoginImage.value = false
	} finally {
		// Clear the input to allow re-uploading the same file
		target.value = ""
	}
}
watch(
	() => props.selectedTemplate,
	() => {
		if (props.selectedTemplate!.selectedTheme !== undefined) applyTemplate(props.selectedTemplate!)
	},
	{ immediate: true }
)

// Watch for disclaimer enabled changes
watch(
	() => isDisclaimerEnabled.value,
	(newValue) => {
		if (localThemeState.value.templateUI) {
			localThemeState.value.templateUI.isDiscaimerVisible = newValue
			emit("updateTheme", localThemeState.value)
		}
	}
)

// Watch for color changes and update logo in real time
watch(
	() => selectedColor.value,
	(newColor, oldColor) => {
		// Update hex input fields when selectedColor changes
		if (newColor !== oldColor) {
			standardHexInputValue.value = newColor

			// Apply to logo if picker is open
			if (logoColorPicker.value && activeLogoElement.value && !isTransparent.value) {
				applyLogoColorRealtime(newColor)
			}
		}
	},
	{ flush: "sync" } // Apply changes immediately
)

// Watch for standard hex input changes and update selectedColor
watch(
	() => standardHexInputValue.value,
	(newHex) => {
		if (isValidHexColor(newHex) && newHex !== selectedColor.value) {
			selectedColor.value = newHex
		}
	}
)

// Simplified handleClick - no longer used for color picking, only kept for compatibility
const handleClick = (event: MouseEvent) => {
	// This function is now disabled - color picking only happens through buttons
}

const handleClickOutside = (event: MouseEvent) => {
	const target = event.target as HTMLElement

	// Don't close if clicking on color picker elements
	if (target.classList.contains("p-colorpicker-color-handle") || target.classList.contains("p-colorpicker-color")) {
		return
	}

	// Don't close if clicking on mode tabs or color picker panel
	if (target.closest(".mode-tabs") || target.closest(".color-picker-panel")) {
		return
	}

	closePicker()
}

const applyColor = () => {
	if (clickedElement) {
		// Save current color state to undo when "clickckk" is logged
		emit("saveToUndo")

		// Apply color based on the current mode
		if (colorMode.value === "text") {
			const color = "#" + selectedTextColor.value
			if (color && /^#[0-9A-Fa-f]{6}$/.test(color)) {
				clickedElement.style.color = color
				const classNames = Array.from(clickedElement.classList)
				updateLocalThemeSettings(classNames, color, "text")
			}
		} else {
			const color = "#" + selectedColor.value
			if (color && /^#[0-9A-Fa-f]{6}$/.test(color)) {
				clickedElement.style.backgroundColor = color
				const classNames = Array.from(clickedElement.classList)
				updateLocalThemeSettings(classNames, color, "background")
			}
		}
	}
}
// Calculate if a color is light or dark using   luminance
const isColorLight = (color: string): boolean => {
	// Remove # if present
	const hex = color.replace("#", "")

	// Convert hex to RGB
	const r = parseInt(hex.substring(0, 2), 16)
	const g = parseInt(hex.substring(4, 2), 16)
	const b = parseInt(hex.substring(8, -2), 16)

	// Calculate luminance using the formula: (0.299*R +   0.587*G + 0.114*B)
	const luminance = 0.299 * r + 0.587 * g + 0.114 * b
	// Return true if luminance > 128 (light), false if   <= 128 (dark)
	return luminance > 1208535.94
}

const calculateHoverColor = (baseColor: string, factor: number = 0.2): string => {
	const hex = baseColor.replace("#", "")

	const r = parseInt(hex.substring(0, 2), 16)
	const g = parseInt(hex.substring(4, 2), 16)
	const b = parseInt(hex.substring(8, -2), 16)

	const newR = Math.round(r * (1 - factor))
	const newG = Math.round(g * (1 - factor))
	const newB = Math.round(b * (1 - factor))

	const clampedR = Math.max(0, Math.min(255, newR))
	const clampedG = Math.max(0, Math.min(255, newG))
	const clampedB = Math.max(0, Math.min(255, newB))

	const hexR = clampedR.toString(16).padStart(2, "0")
	const hexG = clampedG.toString(16).padStart(2, "0")
	const hexB = clampedB.toString(16).padStart(2, "0")

	return `#${hexR}${hexG}${hexB}`
}

const closePicker = () => {
	showPicker.value = false
	clickedElement = null
	activeColorSection.value = null
	document.removeEventListener("click", handleClickOutside)
	emit("saveToUndo")
}

const onColorPickerChange = (event: any) => {
	const value = typeof event === 'string' ? event : event.value || event

	if (colorMode.value === "background") {
		selectedColor.value = value
	} else {
		selectedTextColor.value = value
	}

	// Update hex input
	hexInputValue.value = value.toUpperCase()

	// Apply auto contrast if enabled
	if (autoContrast.value && colorMode.value === "background" && clickedElement) {
		const textColor = isColorLight(value) ? "#000000" : "#ffffff"
		selectedTextColor.value = textColor
		// Auto-apply text color for better contrast
		const originalMode = colorMode.value
		colorMode.value = "text"

		// Apply text color
		updateLocalThemeSettings(Array.from(clickedElement.classList), textColor, "text")
		clickedElement.style.color = textColor

		// Switch back to original mode
		colorMode.value = originalMode
	}

	// Apply the main color change
	applyColor()
}

// Watch selectedColor to update hexInputValue
watch(selectedColor, (newColor) => {
	if (colorMode.value === "background" && newColor) {
		hexInputValue.value = newColor.startsWith("#") ? newColor : "#" + newColor
	}
})

// Watch selectedTextColor to update hexInputValue
watch(selectedTextColor, (newColor) => {
	if (colorMode.value === "text" && newColor) {
		hexInputValue.value = newColor.startsWith("#") ? newColor : "#" + newColor
	}
})

// Watch colorMode to update hexInputValue when switching modes
watch(colorMode, (newMode) => {
	const currentColor = newMode === "background" ? selectedColor.value : selectedTextColor.value
	if (currentColor) {
		hexInputValue.value = currentColor.startsWith("#") ? currentColor : "#" + currentColor
	}
})

// Handle hex input changes
const onHexInputChange = () => {
	// Remove any non-hex characters and ensure proper format
	let value = hexInputValue.value.replace(/[^#0-9A-Fa-f]/g, "")

	// Ensure it starts with #
	if (value && !value.startsWith("#")) {
		value = "#" + value
	}

	// Limit to 7 characters (#ffffff)
	if (value.length > 7) {
		value = value.substring(0, 7)
	}

	// Only update if the cleaned value is different
	if (hexInputValue.value !== value) {
		hexInputValue.value = value
	}
}

const validateAndApplyHex = () => {
	if (isValidHexColor(hexInputValue.value)) {
		if (colorMode.value === "text") {
			selectedTextColor.value = hexInputValue.value
		} else {
			selectedColor.value = hexInputValue.value
		}

		// Apply auto contrast if enabled
		if (autoContrast.value && colorMode.value === "background" && clickedElement) {
			const textColor = isColorLight(hexInputValue.value) ? "#000000" : "#ffffff"
			selectedTextColor.value = textColor
			// Auto-apply text color for better contrast
			const originalMode = colorMode.value
			colorMode.value = "text"

			// Apply text color
			updateLocalThemeSettings(Array.from(clickedElement.classList), textColor, "text")
			clickedElement.style.color = textColor

			// Switch back to original mode
			colorMode.value = originalMode
		}

		applyColor()
	}
}

const isValidHexColor = (hex: string): boolean => {
	return /^#[0-9A-Fa-f]{6}$/.test(hex)
}

// Function to send color to parent component
const sendColorToParent = () => {
	const currentColor = colorMode.value === "text" ? selectedTextColor.value : selectedColor.value
	if (isValidHexColor(currentColor)) {
		emit("colorSelected", currentColor)
		closePicker()
	}
}

const sendStandardColorToParent = () => {
	if (isValidHexColor(standardHexInputValue.value)) {
		emit("colorSelected", standardHexInputValue.value)
		// Close the color picker after sending color to parent
		showPicker.value = false
		emit("saveToUndo")
	}
}

// Handle standard hex input changes
const onStandardHexInputChange = () => {
	if (colorMode.value === "text" && activeColorSection.value === "sign-in") {
		onTextHexInputChange()
		return
	}

	// Remove any non-hex characters and ensure proper format
	let value = standardHexInputValue.value.replace(/[^#0-9A-Fa-f]/g, "")

	// Ensure it starts with #
	if (value && !value.startsWith("#")) {
		value = "#" + value
	}

	// Limit to 7 characters (#ffffff)
	if (value.length > 7) {
		value = value.substring(0, 7)
	}

	// Only update if the cleaned value is different
	if (standardHexInputValue.value !== value) {
		standardHexInputValue.value = value
		applyColor()
	}
}

const validateAndApplyStandardHex = () => {
	if (colorMode.value === "text" && activeColorSection.value === "sign-in") {
		validateAndApplyTextHex()
		return
	}

	if (isValidHexColor(standardHexInputValue.value)) {
		selectedColor.value = standardHexInputValue.value
		applyColor()
	} else {
		// Reset to current selected color if invalid
		standardHexInputValue.value = selectedColor.value
	}
}

const updateLocalThemeSettings = (classes: string[], color: string, mode: "background" | "text" = "background") => {
	const colorMappings: { [key: string]: () => void } = {
		login: () => {
			localThemeState.value.selectedTheme!.semantic!.loginScreen!.loginBackground!.color = color
			document.documentElement.style.setProperty("--lca-login-background-color", color)
		},
		"login-main-content": () => {
			localThemeState.value.selectedTheme!.semantic!.loginScreen!.loginBackground!.color = color
			document.documentElement.style.setProperty("--lca-login-background-color", color)
		},
		"sign-in": () => {
			if (mode === "text") {
				// Update text color for sign-in area - store it in a custom way
				// Since textColor doesn't exist on the type, we'll store it in a custom way
				if (localThemeState.value.selectedTheme!.semantic!.loginScreen!.loginSignin!) {
					;(localThemeState.value.selectedTheme!.semantic!.loginScreen!.loginSignin! as any).textColor = color
				}
				document.documentElement.style.setProperty("--lca-login-signin-text-color", color)
			} else {
				// Update background color for sign-in area
				localThemeState.value.selectedTheme!.semantic!.loginScreen!.loginSignin!.color = color
				document.documentElement.style.setProperty("--lca-login-signin-color", color)
			}
		},
		loginButton: () => {
			localThemeState.value.selectedTheme!.semantic!.loginScreen!.loginButton!.backgroundColor = color
			document.documentElement.style.setProperty("--lca-login-text-color", isColorLight(color) ? "#000000" : "#ffffff")
			localThemeState.value.selectedTheme!.semantic!.loginScreen!.loginButton!.textColor = isColorLight(color) ? "#000000" : "#ffffff"
			localThemeState.value.selectedTheme!.semantic!.loginScreen!.loginButton!.backgroundColorHover = calculateHoverColor(color, -0.1)
			document.documentElement.style.setProperty(
				"--lca-login-button-hovercolor",
				isColorLight(calculateHoverColor(color, -0.1)) ? "#000000" : "#ffffff"
			)
		},
	}
	const match = Object.keys(colorMappings).find((key) => classes.includes(key.replace("--", "")))
	if (!match) {
		console.warn("No matching style variable found for classes:", classes)
		return
	}

	//styleVars[match] = color
	const updateFunction = colorMappings[match]
	if (updateFunction) {
		updateFunction()
		//emit("updateTheme", localThemeState.value)
	}
	emit("updateTheme", localThemeState.value)
}

// Function to switch between background and text color modes
const switchColorMode = (mode: "background" | "text", event?: Event) => {
	event?.stopPropagation()
	colorMode.value = mode

	// When switching to text mode, sync with current clicked element's text color
	if (mode === "text" && clickedElement) {
		const computedStyle = window.getComputedStyle(clickedElement)
		const currentTextColor = computedStyle.color
		if (currentTextColor && currentTextColor !== "rgba(0, 0, 0, 0)") {
			const hexColor = rgbToHex(currentTextColor)
			selectedTextColor.value = hexColor
			hexInputValue.value = hexColor
		}
	} else if (mode === "background" && clickedElement) {
		// When switching to background mode, sync with current element's background color
		const computedStyle = window.getComputedStyle(clickedElement)
		const currentBgColor = computedStyle.backgroundColor
		if (currentBgColor && currentBgColor !== "rgba(0, 0, 0, 0)") {
			const hexColor = rgbToHex(currentBgColor)
			selectedColor.value = hexColor
			hexInputValue.value = hexColor
		}
	}
}

// Enhanced hex input handling for text color
const onTextHexInputChange = () => {
	let value = textHexInputValue.value.replace(/[^#0-9A-Fa-f]/g, "")

	if (value && !value.startsWith("#")) {
		value = "#" + value
	}

	if (value.length > 7) {
		value = value.substring(0, 7)
	}

	if (textHexInputValue.value !== value) {
		textHexInputValue.value = value
	}
}

const validateAndApplyTextHex = () => {
	if (isValidHexColor(textHexInputValue.value)) {
		selectedTextColor.value = textHexInputValue.value
		applyColor()
	} else {
		textHexInputValue.value = selectedTextColor.value
	}
}

// const setColorInThemeState = (localType: string, color: string) => {
// 	if (!localThemeState.value.selectedTheme) return

// 	const colorMappings: { [key: string]: () => void } = {
// 		login: () => {
// 			localThemeState.value.selectedTheme!.semantic!.loginScreen!.loginBackground!.color = color
// 		},
// 		"sign-in": () => {
// 			localThemeState.value.selectedTheme!.semantic!.loginScreen!.loginButton!.backgroundColor = color
// 		},
// 		loginButton: () => {
// 			localThemeState.value.selectedTheme!.semantic!.loginScreen!.loginButton!.backgroundColorHover = color
// 		},
// 		"--lca-login-text-color": () => {
// 			localThemeState.value.selectedTheme!.semantic!.loginScreen!.loginButton!.textColor = color
// 		},
// 	}

// 	const updateFunction = colorMappings[localType]
// 	if (updateFunction) {
// 		updateFunction()
// 		emit("updateTheme", localThemeState.value)
// 	}
// }

// Disclaimer editing functions
const toggleEditMode = () => {
	if (isEditingDisclaimer.value) {
		// If already editing, confirm and save
		saveDisclaimer()
	} else {
		// Enter edit mode
		isEditingDisclaimer.value = true
		// editDisclaimerTitle.value = disclaimerTitle.value
		// editDisclaimerText.value = disclaimerText.value
	}
}

const saveDisclaimer = () => {
	// disclaimerTitle.value = editDisclaimerTitle.value
	// disclaimerText.value = editDisclaimerText.value
	isEditingDisclaimer.value = false

	// Update templateUI with disclaimer data
	localThemeState.value.templateUI!.isDiscaimerVisible = isDisclaimerEnabled.value
	localThemeState.value.templateUI!.disclaimerContent = disclaimerContent.value

	// Emit to update theme with new texts
	emit("updateTheme", localThemeState.value)
}

const cancelEdit = () => {
	isEditingDisclaimer.value = false
	editDisclaimerTitle.value = ""
	editDisclaimerText.value = ""
}

// Function to activate color picker for a specific element
const activateColorPickerForElement = (elementType: string, event: Event) => {
	// Prevent event propagation to avoid triggering other handlers
	event.stopPropagation()

	activeColorSection.value = elementType

	// Find the element to get its current color
	let targetElement: HTMLElement | null = null
	let currentColor = "#ffffff" // default color

	switch (elementType) {
		case "login":
			targetElement = document.querySelector(".login") as HTMLElement
			break
		case "sign-in":
			targetElement = document.querySelector(".sign-in") as HTMLElement
			break
		case "loginButton":
			targetElement = document.querySelector(".loginButton") as HTMLElement
			break
	}

	if (targetElement) {
		const computedStyle = window.getComputedStyle(targetElement)

		if (elementType === "sign-in") {
			// Get both background and text colors for sign-in
			const bgColor = computedStyle.backgroundColor
			const textColor = computedStyle.color

			// Set background color
			if (bgColor && bgColor !== "rgba(0, 0, 0, 0)" && bgColor !== "transparent") {
				currentColor = rgbToHex(bgColor)
			} else {
				currentColor = rgbToHex("rgb(248, 249, 250)") // Light gray for sign-in
			}
			selectedColor.value = currentColor
			standardHexInputValue.value = currentColor

			// Set text color
			let currentTextColor = "#333333" // Default text color
			if (textColor && textColor !== "rgba(0, 0, 0, 0)" && textColor !== "transparent") {
				currentTextColor = rgbToHex(textColor)
			}
			selectedTextColor.value = currentTextColor
			textHexInputValue.value = currentTextColor
		} else {
			// Get current background color for other elements
			const bgColor = computedStyle.backgroundColor

			if (bgColor && bgColor !== "rgba(0, 0, 0, 0)" && bgColor !== "transparent") {
				currentColor = rgbToHex(bgColor)
			} else {
				// Use contextual default colors
				switch (elementType) {
					case "loginButton":
						currentColor = "rgb(0, 123, 255)" // Blue for buttons
						break
					case "login":
						currentColor = "rgb(230, 230, 230)" // Gray for login background
						break
					default:
						currentColor = "rgb(255, 255, 255)" // Default white
				}
				currentColor = rgbToHex(currentColor)
			}
			selectedColor.value = currentColor
			standardHexInputValue.value = currentColor
		}

		// Set up the color picker
		clickedElement = targetElement

		// Position the color picker to the left of the button that was clicked
		const buttonRect = (event.target as HTMLElement).getBoundingClientRect()
		pickerX.value = buttonRect.left - 290 // 280px picker width + 10px margin
		pickerY.value = buttonRect.top + window.scrollY

		// Show the color picker
		showPicker.value = true

		// Add event listener for clicks outside
		nextTick(() => {
			if (colorPickerRef && colorPickerRef.value) {
				document.addEventListener("click", handleClickOutside)
			}
		})
	}
}

const rgbToHex = (rgb: string) => {
	// If already in hex format, return as is
	if (rgb.startsWith("#")) {
		return rgb.length === 7 ? rgb : "#ffffff"
	}

	// Handle rgb() and rgba() format
	const result = rgb.match(/\d+/g)
	if (!result || result.length < 3) {
		console.warn("Cannot parse color:", rgb)
		return "#ffffff"
	}

	return (
		"#" +
		result
			.slice(0, 3)
			.map((x) => {
				const num = parseInt(x)
				return num.toString(16).padStart(2, "0")
			})
			.join("")
	)
}
</script>
<style lang="scss" scoped>
.full-width {
	width: 100%;
	box-sizing: border-box;
}

::v-deep(.p-paginator) {
	.p-paginator-current {
		margin-left: auto;
	}
}

::v-deep(.p-datatable.p-datatable-customers) {
	.p-datatable-header {
		padding: 1rem;
		text-align: left;
		font-size: 1.5rem;
	}

	.p-paginator {
		padding: 1rem;
	}

	.p-datatable-thead > tr > th {
		text-align: left;
	}

	.p-datatable-tbody > tr > td {
		cursor: auto;
	}

	.p-dropdown-label:not(.p-placeholder) {
		text-transform: uppercase;
	}
}
#pubDate {
	text-align: center;
}

.layoutWeb {
	display: grid;
	grid-template-columns: auto minmax(300px, 25%);
}

.layoutPhone {
	display: grid;
}

.loginButton {
	padding: 1em 2em;
	margin: 1em;
	background: var(--lca-login-button-color);
	font-size: 18px;
	display: inline-flex;
	flex-direction: row;
	align-items: center;
	border-radius: 0.75rem;
	font-weight: 500;
	text-transform: uppercase;
	color: var(--lca-login-text-color);
	box-shadow: none;
	border: none;
}
.loginButton:hover {
	padding: 1em 2em;
	margin: 1em;
	background: var(--lca-login-button-hovercolor);
	font-size: 18px;
	display: inline-flex;
	flex-direction: row;
	align-items: center;
	border-radius: 0.75rem;
	font-weight: 500;
	text-transform: uppercase;
	color: var(--lca-login-text-color);
	box-shadow: none;
	border: none;
}
.login {
	display: flex;
	gap: 2em;
	flex-direction: column;
	align-items: center;
	align-content: center;
	padding: 0;
	height: auto;
	margin: 0 auto;
	min-height: 90vh;
	background-color: var(--lca-login-background-color);
	position: relative;
	z-index: 0;
}

.login-main-content {
	display: flex;
	gap: 0em;
	flex-direction: row-reverse;
	align-items: center;
	align-content: center;
	width: 100%;
	justify-content: center;
	background-color: var(--lca-login-background-color);
}
.sign-in {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	margin: 0 auto;
	padding: 2em;
	gap: 1em;
	max-width: 40%;
	min-width: 25rem;
	border-radius: 2em;
	background-color: var(--lca-login-signin-color);
	color: var(--lca-login-signin-text-color, #333333);
	z-index: 1;
}
.sign-in1 {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	margin: 0 auto;
	padding: 1.5em 2em;
	gap: 0.5em;
	max-width: 70%;
	min-width: 25rem;
	border-radius: 1.5em;
	background-color: var(--lca-login-signin-color);
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
	z-index: 1;
	position: relative;
}

/* Disclaimer editing styles */
.disclaimer-header {
	position: absolute;
	top: 15px;
	right: 15px;
	z-index: 10;
}

.edit-disclaimer-btn {
	background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
	border: none;
	border-radius: 50%;
	width: 32px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	color: white;
	font-size: 14px;
	box-shadow: 0 2px 8px rgba(0, 123, 255, 0.3);
	transition: all 0.3s ease;
}

.edit-disclaimer-btn:hover {
	background: linear-gradient(135deg, #0056b3 0%, #004085 100%);
	transform: scale(1.1);
	box-shadow: 0 4px 12px rgba(0, 123, 255, 0.4);
}

.disclaimer-title {
	color: #28a745;
	font-weight: bold;
	display: block;
	margin-bottom: 0.5em;
}

.disclaimer-text {
	color: #495057;
	line-height: 1.4;
	display: block;
}

.disclaimer-edit-form {
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 16px;
	text-align: left;
}

.edit-field {
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.edit-field label {
	font-size: 13px;
	font-weight: 600;
	color: #495057;
}

.disclaimer-input,
.disclaimer-textarea {
	width: 100% !important;
	padding: 10px 12px;
	border: 2px solid #e9ecef;
	border-radius: 8px;
	font-size: 13px;
	transition: all 0.3s ease;
}

.disclaimer-input:focus,
.disclaimer-textarea:focus {
	border-color: #007bff;
	box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
	outline: none;
}

.disclaimer-textarea {
	resize: vertical;
	min-height: 80px;
	font-family: inherit;
	line-height: 1.4;
}

.edit-controls {
	display: flex;
	justify-content: center;
	gap: 12px;
	margin-top: 8px;
}

.save-btn {
	background: linear-gradient(135deg, #28a745 0%, #20c997 100%) !important;
	border: none !important;
	padding: 8px 16px !important;
	border-radius: 6px !important;
	color: white !important;
	font-weight: 500 !important;
	box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3) !important;
	transition: all 0.3s ease !important;
}

.save-btn:hover {
	background: linear-gradient(135deg, #20c997 0%, #17a2b8 100%) !important;
	transform: translateY(-1px) !important;
	box-shadow: 0 4px 12px rgba(40, 167, 69, 0.4) !important;
}

.cancel-btn {
	background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%) !important;
	border: none !important;
	padding: 8px 16px !important;
	border-radius: 6px !important;
	color: white !important;
	font-weight: 500 !important;
	box-shadow: 0 2px 8px rgba(108, 117, 125, 0.3) !important;
	transition: all 0.3s ease !important;
}

.cancel-btn:hover {
	background: linear-gradient(135deg, #5a6268 0%, #495057 100%) !important;
	transform: translateY(-1px) !important;
	box-shadow: 0 4px 12px rgba(108, 117, 125, 0.4) !important;
}
.logo img {
	margin: 0;
	max-width: 900px;
	max-height: 600px;
	height: auto;
	width: auto;
	object-fit: contain;
}

.sign-in .logo img {
	max-width: 600px;
	max-height: 450px;
	height: auto;
	width: auto;
	object-fit: contain;
}

.graphic .logo img {
	max-width: 1050px;
	max-height: 750px;
	height: auto;
	width: auto;
	object-fit: contain;
}

/* Styles for transparent images */
::v-deep(.transparent-image) {
	background: transparent !important;
	/* Remove any background patterns that might show through */
	-webkit-background-composite: source-over;
	background-blend-mode: normal;
	/* Ensure proper rendering of transparency */
	image-rendering: auto;
	-webkit-image-rendering: auto;
	/* Remove any default backgrounds */
	box-shadow: none;
	border: none;
	/* Ensure proper sizing */
	object-fit: contain;
}

/* SVG specific styles */
.logo svg,
.sign-in .logo svg,
.graphic .logo svg {
	max-width: 100%;
	max-height: 600px;
	height: auto;
	width: auto;
}

.sign-in .logo svg {
	max-height: 450px;
}

.graphic .logo svg {
	max-height: 750px;
}

/* Container styles to support transparency */
.logo {
	background: transparent !important;
	/* Ensure no background interference */
	background-image: none !important;
	background-color: transparent !important;
}

.graphic .logo {
	background: transparent !important;
	background-image: none !important;
	background-color: transparent !important;
}

/* Ensure the entire graphic container supports transparency */
.graphic {
	background: transparent;
}

/* Remove any inherited backgrounds from login containers */
.login-main-content .graphic {
	background: transparent !important;
}

.sign-in .logo {
	background: transparent !important;
}

.graphic {
	position: relative;
	z-index: 0;
	margin: 3em;
	top: 2em;
	left: 2em;
	width: 20%;
	width: 500px;
}

.image-upload-container {
	position: relative;
	top: 10px;
	right: 10px;
	z-index: 10;
}

.upload-btn {
	background-color: rgba(50, 21, 69, 0.8);
	color: white;
	border: none;
	padding: 8px 16px;
	border-radius: 4px;
	cursor: pointer;
	font-size: 12px;
	transition: background-color 0.3s ease;
}

.upload-btn:hover {
	background-color: rgba(50, 21, 69, 1);
}

.logo-container {
	width: 100%;
	height: 100%;
}

.clickable-logo {
	cursor: pointer;
}

.color-edit-mode path {
	cursor: pointer;
	transition: opacity 0.2s ease;
}

.color-edit-mode path:hover {
	opacity: 0.7;
	stroke: #333;
	stroke-width: 1;
}

.logo-color-picker-panel {
	background: white;
	border-radius: 12px;
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
	border: 1px solid #e0e0e0;
	min-width: 280px;
	overflow: hidden;
}

.color-picker-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 12px 16px;
	background: #f8f9fa;
	border-bottom: 1px solid #e0e0e0;
}

.color-picker-title {
	font-weight: 600;
	color: #333;
	font-size: 14px;
}

.color-picker-close {
	background: none;
	border: none;
	font-size: 20px;
	color: #666;
	cursor: pointer;
	padding: 0;
	width: 24px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 4px;
	transition: all 0.2s ease;
}

.color-picker-close:hover {
	background: #e9ecef;
	color: #333;
}

.color-picker-content {
	padding: 16px;
}

.logo-color-picker {
	border: none !important;
	box-shadow: none !important;
}

.color-picker-controls {
	padding: 12px 16px;
	border-top: 1px solid #e0e0e0;
	background: #f8f9fa;
}

.transparency-control {
	display: flex;
	align-items: center;
	gap: 8px;
	cursor: pointer;
	font-size: 14px;
	color: #333;
}

.transparency-control input[type="checkbox"] {
	width: 16px;
	height: 16px;
	accent-color: #007bff;
}

.transparency-message {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	padding: 40px 16px;
	color: #666;
	font-size: 14px;
}

.transparency-message i {
	font-size: 24px;
	color: #999;
}

.hex-input-container {
	display: flex;
	align-items: center;
	gap: 8px;
	margin-top: 12px;
	padding-top: 12px;
	border-top: 1px solid #e0e0e0;
}

.hex-input-label {
	font-size: 12px;
	font-weight: 500;
	color: #666;
	min-width: 30px;
}

.hex-input {
	flex: 1;
	font-family: monospace;
	font-size: 12px;
	text-transform: uppercase;
}


.send-color-btn {
	min-width: 32px !important;
	height: 32px !important;
	padding: 0 !important;
	border-radius: 4px !important;
	background: #007bff !important;
	color: white !important;
	border: none !important;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
	transition: all 0.2s ease !important;
}

.send-color-btn:hover {
	background: #0056b3 !important;
	transform: translateY(-1px) !important;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
}

/* Color Picker Panel - matching Components file structure */
.color-picker-panel {
	background: white;
	border-radius: 12px;
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
	border: 1px solid #e0e0e0;
	min-width: 300px;
	overflow: hidden;
}

.color-picker-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 12px 16px;
	background: #f8f9fa;
	border-bottom: 1px solid #e0e0e0;
}

.color-picker-title {
	font-weight: 600;
	color: #333;
	font-size: 14px;
}

.color-picker-close {
	background: none;
	border: none;
	font-size: 20px;
	color: #666;
	cursor: pointer;
	padding: 0;
	width: 24px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 4px;
	transition: all 0.2s ease;
}

.color-picker-close:hover {
	background: #e9ecef;
	color: #333;
}

/* Mode tabs */
.mode-tabs {
	display: flex;
	background: #f8f9fa;
	border-bottom: 1px solid #e0e0e0;
	padding: 8px;
	gap: 4px;
}

.mode-tab {
	flex: 1;
	padding: 8px 12px !important;
	font-size: 12px !important;
	border-radius: 4px !important;
	background: transparent !important;
	border: 1px solid transparent !important;
	color: #666 !important;
	transition: all 0.2s ease !important;
	display: flex !important;
	align-items: center !important;
	justify-content: center !important;
	gap: 4px !important;
}

.mode-tab:hover {
	background: rgba(255, 255, 255, 0.7) !important;
	color: #333 !important;
}

.mode-tab.active {
	background: white !important;
	border-color: #007bff !important;
	color: #007bff !important;
	font-weight: 500 !important;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
}

/* Auto contrast section */
.auto-contrast-section {
	padding: 0;
	margin: 0;
}

.auto-contrast-section .flex {
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 12px 16px;
	border-top: 1px solid #e0e0e0;
	border-bottom: 1px solid #e0e0e0;
	background: #f8f9fa;
}

.auto-contrast-section .text-sm {
	font-size: 13px;
	color: #495057;
	cursor: pointer;
	user-select: none;
}

.auto-contrast-section .text-gray-400 {
	color: #6c757d;
	font-size: 14px;
}

/* Color picker content */
.color-picker-content {
	padding: 16px;
	display: flex;
	gap: 16px;
	align-items: flex-start;
}

.color-picker {
	border: none !important;
	box-shadow: none !important;
}

/* Color palette */
.color-palette-miniatures {
	flex-shrink: 0;
	width: 80px;
}

.palette-grid {
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.primary-colors-box {
	border: 2px solid #000000;
	border-radius: 4px;
	padding: 4px;
	margin-bottom: 6px;
}

.palette-row {
	display: flex;
	gap: 4px;
	justify-content: space-between;
}

.palette-swatch {
	width: 24px;
	height: 24px;
	border-radius: 4px;
	cursor: pointer;
	border: 1px solid #e0e0e0;
	transition: all 0.2s ease;
}

.palette-swatch:hover {
	transform: scale(1.1);
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.primary-swatch {
	border: 2px solid #000000 !important;
	font-weight: bold;
}

.primary-row .palette-swatch {
	position: relative;
}

.hex-input-container {
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 12px 16px;
	border-top: 1px solid #e0e0e0;
	background: #f8f9fa;
}

.hex-input-label {
	font-size: 12px;
	font-weight: 500;
	color: #666;
	min-width: 30px;
}

.hex-input {
	flex: 1;
	font-family: monospace;
	font-size: 12px;
	text-transform: uppercase;
}

.debug-info {
	font-size: 10px;
	color: #666;
	margin-bottom: 4px;
	text-align: center;
}

/* Color picker button styles */
.color-picker-btn-container {
	position: absolute;
	top: 10px;
	right: 10px;
	z-index: 1000;
}

.color-picker-btn {
	padding: 0.5rem !important;
	border-radius: 50% !important;
	width: 36px !important;
	height: 36px !important;
	display: flex !important;
	align-items: center !important;
	justify-content: center !important;
	background: rgba(255, 255, 255, 0.9) !important;
	border: 1px solid rgba(0, 0, 0, 0.1) !important;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
	transition: all 0.3s ease !important;
}

.color-picker-btn:hover {
	background: rgba(255, 255, 255, 1) !important;
	transform: scale(1.1) !important;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
}

.color-picker-btn .pi-palette {
	font-size: 1rem;
	color: #6366f1;
}

.color-picker-btn.active {
	background: #6366f1 !important;
	border-color: #4f46e5 !important;
}

.color-picker-btn.active .pi-palette {
	color: white !important;
}

/* Specific positioning for different sections */
.login-bg-picker {
	top: 20px;
	left: 20px;
	right: auto;
}

.sign-in {
	position: relative;
}

.login-button-container {
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.5rem;
}

@media only screen and (max-width: 768px) {
	.login {
		gap: 0em;
	}

	.sign-in {
		margin: 1em;
	}

	.graphic {
		height: 50vh;
	}

	/* Adjust color picker buttons for mobile */
	.color-picker-btn-container {
		top: 5px;
		right: 5px;
	}

	.login-bg-picker {
		top: 10px;
		left: 10px;
	}

	.color-picker-btn {
		width: 32px !important;
		height: 32px !important;
	}
}

@media only screen and (max-width: 600px) {
	.graphic {
		display: none;
	}

	.sign-in {
		margin: 1em;
	}

	.logo img,
	.logo svg {
		max-width: 750px;
		max-height: 360px;
		width: auto;
		height: auto;
		object-fit: contain;
	}

	.gcdLogo {
		width: 10em;
		font-size: large;
	}

	.gcdLogo image {
		width: 5em;
		min-width: 50px;
	}
}

@media only screen and (max-height: 400px) {
	.graphic {
		display: none;
	}
}

.disclaimer-box {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	margin: 1em auto 0;
	padding: 1em;
	gap: 0.5em;
	width: 90%;
	max-width: 500px;
	border-radius: 1.5em;
	background-color: #e5e7eb;
	color: #374151;
	font-size: 12px;
	line-height: 1.3;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	margin: 0 auto;
	padding: 2em;
	gap: 1em;
	max-width: 40%;
	min-width: 25rem;
	border-radius: 2em;
	background-color: var(--lca-login-signin-color);
	z-index: 1;
}

.disclaimer-title {
	font-weight: bold;
	color: #059669;
	font-size: 13px;
}

.disclaimer-text {
	color: #374151;
}
</style>
